module.exports = __webpack_public_path__ + "img/task-banner.ea92b80b.png";